export { BaseChatsListModule } from './base-chats-list.module';
